export default "__VITE_ASSET__DvF5lg8Q__"